import type { OnboardingState, PricingStatus } from './Onboarding.types'
import type { LpgPricingTiers } from '@/types/krakend.types'
import type { CountryCode, CompanyAddressInput } from '@/types/shopify/admin/api-types'

export const DEFAULT_ONBOARDING_DATA = {
  customerState: 'NOT_ONBOARDED' as OnboardingState,
  displayAddress: '',
  onboardingForm: {
    firstName: '',
    lastName: '',
    phone: '',
    isBusiness: false,
    businessName: '',
    ABN: '',
    industry: '',
    address: {
      address1: '',
      city: '',
      countryCode: 'AU' as CountryCode,
      zip: '',
      zoneCode: '',
    } as CompanyAddressInput,
  },
}

export const DEFAULT_PRODUCT_DATA = {
  productForm: {
    pricingStatus: 'NEW_ORDER' as PricingStatus,
    branchCode: '',
    pricesByQuantity: null as LpgPricingTiers | null,
    quantity: 1,
    appliances: {} as Record<string, boolean | string>,
  },
}

export const INDUSTRY_OPTIONS = [
  { label: 'Automotive', value: 'automotive' },
  { label: 'Construction', value: 'construction' },
  { label: 'Healthcare', value: 'healthcare' },
  { label: 'Tourism & Hospitality', value: 'tourism-hospitality' },
  { label: 'Farming & Agriculture', value: 'farming-agriculture' },
  { label: 'Oil & Gas', value: 'oil-gas' },
]
